import React, {Component} from 'react'
import BaronSimpleDatePicker from '../BaronSimpleDatePicker'
import ZipInput from '../ZipInput'
import ClientSideCacheController from '../ClientSideCacheController'
import {ResponsiveContainer, BarChart, Legend, Bar} from 'recharts'
import Analytics from '../Analytics'

class BaronAlmanac extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    this.affiliate = props.affiliate;
    this.state = this.massageData()
  }

  componentDidMount() {
    if(typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)

    ClientSideCacheController.get('historic').then((h)=>{
      this.setState(this.massageData(h))
    })

  }

  handleDayChange = (d) => {
    console.log(d);
    //d = {month,day}
    ClientSideCacheController.get('historic',d).then((h)=>{
      this.setState(this.massageData(h))
    })
  }

  massageData = (h) => {
    let state = {
      city: '',
      state: '',
      high: 0,
      averageHigh: 0,
      recordHigh: 0,
      recordHighYear: '',
      low: 0,
      averageLow: 0,
      recordLow: 0,
      recordLowYear: '',
      precip: 0,
      precipMTD: 0,
      precipYTD: 0,
      snow: 0,
      snowMTD: 0

    }
    if(!h)
      return state
    try{
      state.city = h.city
      state.state = h.stateAbbrev

      state.high = h.this_day.temperature.max.value
      state.averageHigh = h.historic.temperature.max.normal
      state.recordHigh = h.historic.temperature.max.record.value
      state.recordHighYear = h.historic.temperature.max.record.year[0]

      state.low = h.this_day.temperature.min.value
      state.averageLow = h.historic.temperature.min.normal
      state.recordLow = h.historic.temperature.min.record.value
      state.recordLowYear = h.historic.temperature.min.record.year[0]

      state.precip = h.this_day.precipitation.day
      state.precipMTD = h.this_day.precipitation.month_to_date
      state.precipYTD = h.this_day.precipitation.since_january_1

      state.snow = h.this_day.snow.day
      state.snowMTD = h.this_day.snow.month_to_date

      return state
    }
    catch (e){
      console.log('baron historic data not cannonical');
      return state
    }

  }




  render() {
    if (!this.state.high) {
      return null
    }
    try{
      return (
        <div className='gnm-baron-almanac hidden-xs hidden-sm'>
          <div className='row'>
            <div className='col-xs-12'>
              <div >
                <h5 className="big-title"><span>Historic Climate Data for </span>
                <ZipInput>
                  <a className="dark">{this.state.city},{this.state.state}</a>
                </ZipInput>

              </h5>
                <BaronSimpleDatePicker onDayChange={this.handleDayChange} />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-3'>
              <Chart  title="High" data={[{
                  label: 'Recorded',
                  value: this.state.high,
                  color:'rgb(198,0,16)'
                },
                {
                  label: 'Average',
                  value: this.state.averageHigh,
                  color:'rgb(129,4,14)'
                },
                {
                  label: 'Record',
                  value: this.state.recordHigh,
                  color:'rgb(71,0,3)'
                }]}

                 recordYear={this.state.recordHighYear}/>

            </div>
            <div className='col-xs-3 '>
              <Chart  title="Low"  data={[{
                  label: 'Recorded',
                  value: this.state.low,
                  color:'rgb(60,156,187	)'
                },
                {
                  label: 'Average',
                  value: this.state.averageLow,
                  color:'rgb(17,56,72)'
                },
                {
                  label: 'Record',
                  value: this.state.recordLow,
                  color:'rgb(15,36,51)'
                }]}

                 recordYear={this.state.recordLowYear}/>
            </div>
            <div className='col-xs-3 '>
              <Chart  title="Precipitation"  data={[{
                  label: 'Recorded',
                  value: this.state.precip,
                  color:'rgb(48,183,11)'
                },
                {
                  label: 'MTD',
                  value: this.state.precipMTD,
                  color:'rgb(29,112,7)'
                },
                {
                  label: 'YTD',
                  value: this.state.precipYTD,
                  color:'rgb(13,50,4)'
                }]}

                 />
            </div>
            <div className='col-xs-3 '>
              <Chart title="Snow" data={[{
                  label: 'Recorded',
                  value: this.state.snow,
                  color:'rgb(116,0,217)'
                },
                {
                  label: 'MTD',
                  value: this.state.snowMTD,
                  color:'rgb(71,0,130)'
                },
                {
                  label: 'YTD',
                  value: 0,
                  color:'rgb(32,7,54)'
                }]}
                hideYtd={true}
                 />
            </div>
          </div>
        </div>
      )
    }catch(e){
      e.message += ' in Almanac'
      Analytics.reportError(e)
    }
  }

}

const Chart = (props) =>{
  let max = -999999
  let min = 999999
  let percentBottomOffset = 0.19

  props.data.map((d)=>{
    if(d.value > max)
      max = d.value
    if(d.value < min)
      min = d.value
  })

  let scale = max == min ? 1 : (1-percentBottomOffset)/(max - min)
  function mapToPercent(x){
    let percent = x - min
    percent = percent * scale + percentBottomOffset;
    return percent * 100;
  }
  function barStyle(d){
    let percent = mapToPercent(d.value)
    return {
      height: '140px',
      background: `linear-gradient(to top, ${d.color} ${percent}%, transparent ${percent}%)`,
    }
  }
  function recordStyle(d){
    let percent = mapToPercent(d.value)
    return{
      bottom: percent + '%'
    }
  }

  return(
    <div className='chart'>
      <h6>{props.title}</h6>
      <div className='bar' style={barStyle(props.data[0])}>
        <div className='value'>{props.data[0].value}</div>
        <div className='name'>{props.data[0].label}</div>
      </div>
      <div className='bar' style={barStyle(props.data[1])}>
        <div className='value'>{props.data[1].value}</div>
        <div className='name'>{props.data[1].label}</div>
      </div>
      { props.hideYtd ? null : (
        <div className='bar' style={barStyle(props.data[2])}>
          <div className='value'>{props.data[2].value}</div>
          <div className='name'>{props.data[2].label}</div>
          <div className='record' style={recordStyle(props.data[2])} >
            {props.recordYear}
          </div>
        </div>
      )}

    </div>
  )
}

export default BaronAlmanac



// WEBPACK FOOTER //
// ./app/components/custom/ssr/BaronAlmanac/index.js